import { createEvent } from 'effector';
import { type PayoutTraderFilters } from '~/entities/payout';

export const setTradersFilter = createEvent<PayoutTraderFilters>();
